/* Bonsai Matcha — Subscription badges + localized upsell popup v9 */
(function () {
  var lang = (document.documentElement.lang || '').slice(0, 2).toLowerCase();
  var copies = {
    en: {
      subscribeTitle: 'Subscribe and Save',
      popular: 'Most Popular',
      value: 'Best Value',
    },
    es: {
      subscribeTitle: 'Suscríbete y ahorra',
      popular: 'Más popular',
      value: 'Mejor precio',
    },
    de: {
      subscribeTitle: 'Abonnieren und sparen',
      popular: 'Am beliebtesten',
      value: 'Bestes Angebot',
    },
    fr: {
      subscribeTitle: 'Abonnez-vous et économisez',
      popular: 'Le plus populaire',
      value: 'Meilleur choix',
    },
    nl: {
      subscribeTitle: 'Abonneer en bespaar',
      popular: 'Meest populair',
      value: 'Beste keuze',
    },
    it: {
      subscribeTitle: 'Abbonati e risparmia',
      popular: 'Più popolare',
      value: 'Miglior scelta',
    },
    hr: {
      subscribeTitle: 'Pretplatite se i uštedite',
      popular: 'Najpopularnije',
      value: 'Najbolji izbor',
    },
    sv: {
      subscribeTitle: 'Prenumerera och spara',
      popular: 'Mest populär',
      value: 'Bästa valet',
    }
  };
  var copy = copies[lang] || copies.en;
  var subscriptionTitles = Object.keys(copies).map(function (locale) {
    return copies[locale].subscribeTitle;
  });

  /* 1. SUBSCRIPTION LABELS + BADGES */
  /* Match "10%" / "10 %" as a discount, not any 10 or 15 inside a price. */
  var TEN_PERCENT = /(^|[^\d.,])10\s?%/;
  var FIFTEEN_PERCENT = /(^|[^\d.,])15\s?%/;

  function addBadges() {
    var fieldset = document.querySelector('.shopify_subscriptions_fieldset');
    if (!fieldset) return false;

    var groupNames = document.querySelectorAll('.group_name');
    groupNames.forEach(function (name) {
      /* Only write when it differs: every write wakes the page watcher below, and an unconditional write loops forever and freezes the page. */
      if (name.textContent !== copy.subscribeTitle && subscriptionTitles.indexOf((name.textContent || '').trim()) !== -1) {
        name.textContent = copy.subscribeTitle;
      }
    });

    var labels = fieldset.querySelectorAll('label');
    if (!labels.length) return false;
    labels.forEach(function (label) {
      if (label.querySelector('.bonsai-badge')) return;
      var text = label.textContent || '';
      if (TEN_PERCENT.test(text)) {
        var b = document.createElement('span');
        b.className = 'bonsai-badge';
        b.textContent = copy.popular;
        b.style.cssText = 'display:inline-block;background:#4a7c59;color:#fff;font-size:0.6rem;font-weight:700;padding:2px 7px;border-radius:3px;margin-left:8px;vertical-align:middle;letter-spacing:0.05em;text-transform:uppercase;';
        label.appendChild(b);
      } else if (FIFTEEN_PERCENT.test(text)) {
        var b2 = document.createElement('span');
        b2.className = 'bonsai-badge';
        b2.textContent = copy.value;
        b2.style.cssText = 'display:inline-block;background:#c8570a;color:#fff;font-size:0.6rem;font-weight:700;padding:2px 7px;border-radius:3px;margin-left:8px;vertical-align:middle;letter-spacing:0.05em;text-transform:uppercase;';
        label.appendChild(b2);
      }
    });
    return true;
  }

  [200, 400, 900, 1800, 3500].forEach(function (delay) {
    setTimeout(addBadges, delay);
  });

  function watchSubscriptionBlock() {
    var observer = new MutationObserver(addBadges);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 10000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchSubscriptionBlock, { once: true });
  } else {
    watchSubscriptionBlock();
  }

})();
